<template>
  <div>
    <a :href="`mailto:${value}`" v-if="validateEmail">{{ value }}</a>
    <a :href="`${value}`" target="_blank" v-else-if="validateUrl">{{ value }}</a>
    <router-link
      :to="`${clientRoute}/edit/${row.id}/`"
      class="link text-primary ripple"
      v-else
    >{{ tableValue }}</router-link>
  </div>
</template>
<script>
export default {
  name: 'grid-cell-string',
  props: {
    col: Object,
    row: Object,
    resource: String,
    value: {
      default: () => ''
    }
  },
  computed: {
    tableValue () {
      if (typeof this.value === 'string') {
        return this.value
      }
      if (Array.isArray(this.value)) {
        return this.value.join(', ')
      }
    },
    clientRoute () {
      return this.$store.state[this.$route.meta.resource].clientRoute
    },
    validateEmail () {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.value).toLowerCase())
    },
    validateUrl () {
      let elm
      if (!elm) {
        elm = document.createElement('input')
        elm.setAttribute('type', 'url')
      }
      elm.value = this.value
      return elm.validity.valid
    }
  }
}
</script>
